{
  "title": "Stock in & out",
  "subtitle": "Every receipt, issue, correction and opening stock, newest first.",
  "export": "Export to Excel",
  "status": {
    "draft": "Draft",
    "pending_approval": "Awaiting approval",
    "validated": "Validated",
    "cancelled": "Cancelled",
    "reversed": "Reversed"
  },
  "types": {
    "stockIn": "Stock in",
    "stockOut": "Stock out",
    "adjustment": "Adjustment",
    "openingStock": "Opening stock",
    "transfer": "Transfer",
    "count": "Count",
    "order": "Order"
  },
  "subtypes": {
    "stockIn": "Receipt",
    "stockOut": "Issue",
    "adjustment": "Correction",
    "openingStock": "Start of use"
  },
  "outTypes": {
    "sale": "Sale",
    "consumption": "Consumption",
    "internal_use": "Internal use"
  },
  "tabs": {
    "all": "All",
    "stockIn": "Stock in",
    "stockOut": "Stock out",
    "adjustment": "Adjustments",
    "openingStock": "Opening stock"
  },
  "how": {
    "title": "How it works",
    "draft": "prepare freely, nothing moves",
    "validated": "stock changes, locked for good",
    "reversed": "a mistake is undone by a new entry"
  },
  "columns": {
    "number": "Number",
    "type": "Type",
    "when": "When · by",
    "date": "Date",
    "location": "Location",
    "partner": "From / to · reference",
    "lines": "Lines",
    "value": "Value",
    "status": "Status",
    "product": "Product"
  },
  "list": {
    "search": "Number, supplier, customer or reference",
    "status": "Status",
    "anyStatus": "Any status",
    "today": "Today",
    "yesterday": "Yesterday",
    "lines_one": "{{count}} line",
    "lines_other": "{{count}} lines",
    "negativeConfirmed": "Negative stock confirmed",
    "waitingManager": "Waiting for a manager",
    "draftDiscarded": "Draft discarded",
    "emptyTitle": "No operation here yet",
    "emptyText": "Receive stock, issue it or record your opening stock with New operation.",
    "showing_one": "Showing {{count}} operation",
    "showing_other": "Showing {{count}} operations",
    "loadMore": "Load more"
  },
  "editor": {
    "new": "New",
    "title": {
      "stockIn": "Receive stock",
      "stockOut": "Issue stock",
      "adjustment": "Correct stock",
      "openingStock": "Opening stock"
    },
    "headerTitle": {
      "stockIn": "Where and from whom",
      "stockOut": "Where and to whom",
      "adjustment": "Where and why",
      "openingStock": "Where and when"
    },
    "linesTitle": {
      "stockIn_one": "Products received · {{count}} line",
      "stockIn_other": "Products received · {{count}} lines",
      "stockOut_one": "Products issued · {{count}} line",
      "stockOut_other": "Products issued · {{count}} lines",
      "adjustment_one": "What changes · {{count}} line",
      "adjustment_other": "What changes · {{count}} lines",
      "openingStock_one": "What you have · {{count}} line",
      "openingStock_other": "What you have · {{count}} lines"
    },
    "saving": "Saving…",
    "saved": "Saved automatically at {{time}} · stock has not changed yet",
    "notSaved": "Saved automatically as soon as you add a product",
    "sentBack": "{{name}} sent this back",
    "into": "Into location",
    "from": "From location",
    "choose": "Choose…",
    "allLocations": "All locations",
    "outType": "Type of issue",
    "receivedFrom": "Received from",
    "issuedTo": "Issued to",
    "theirReference": "Their reference",
    "reason": "Reason",
    "whatHappened": "What happened?",
    "note": "Note",
    "scannerReady": "Scanner ready",
    "scanPlaceholder": "Scan a barcode, or type a product name or SKU, then press Enter",
    "scanAgain": "Scanning again adds +1",
    "noMatch": "No product matches. Check the code, or create the product first.",
    "justScanned": "Just scanned",
    "minusOne": "One less",
    "plusOne": "One more",
    "putIn": "Put in",
    "takeFrom": "Take from",
    "now": "Now",
    "quantity": "Quantity",
    "change": "Change",
    "leftAfter": "Left after",
    "unitCost": "Unit cost (TND)",
    "lineTotal": "Line total",
    "add": "+ Add",
    "remove": "− Remove",
    "sameAsAbove": "Same as above",
    "costFromProduct": "Reference cost price",
    "firstReceipt": "First receipt: the average cost starts at {{cost}}",
    "averageWillGo": "Average cost will go from {{from}} to {{to}}",
    "removeLine": "Remove the line",
    "noLines": "No product yet: scan a barcode or type a name above.",
    "summary": "Summary",
    "totalValue": "Total value",
    "explain": {
      "stockIn": "When you validate, stock goes up in this location, the average cost of each product is updated, and the receipt is locked.",
      "stockOut": "When you validate, stock goes down at the current average cost, and the issue is locked. Going below zero asks for a confirmation.",
      "adjustment": "When you validate, stock is corrected at the current average cost. A large correction waits for a manager.",
      "openingStock": "When you validate, these quantities and costs become the starting stock of each product."
    },
    "validate": {
      "stockIn": "Validate receipt",
      "stockOut": "Validate issue",
      "adjustment": "Validate correction",
      "openingStock": "Validate opening stock"
    },
    "validated": {
      "stockIn": "Receipt {{number}} validated",
      "stockOut": "Issue {{number}} validated",
      "adjustment": "Correction {{number}} validated",
      "openingStock": "Opening stock {{number}} validated"
    },
    "sentForApproval": "Sent to a manager: it is above the approval limit",
    "fixIssues": "Some information is missing: see the fields in red",
    "cannotValidate": "Your role prepares drafts; someone allowed to validate will finish it.",
    "keepDraft": "Keep as draft",
    "discard": "Discard draft",
    "discardTitle": "Discard this draft?",
    "discardText": "Nothing has moved. The draft keeps its number and shows as Cancelled.",
    "discarded": "Draft discarded",
    "shortcut": "Shortcut: Ctrl + Enter to validate",
    "customizationNone": "Not chosen",
    "amountDue": "Amount to pay the supplier",
    "amountDueHint": "Their invoice total when it differs from the goods value (VAT, transport, stamp duty)."
  },
  "negative": {
    "title_one": "{{count}} product will go below zero",
    "title_other": "{{count}} products will go below zero",
    "text": "You are taking out more than the system shows in {{places}}. You can continue, but it will be saved with your name and shown as negative stock until it is fixed.",
    "askManager": "You are taking out more than the system shows. Only people allowed to confirm negative stock can continue: ask a manager.",
    "blocked": "Negative stock is blocked in Configuration. Receive the missing quantity or correct the stock first.",
    "productLocation": "Product · location",
    "now": "Now",
    "change": "Taking",
    "after": "After",
    "checkbox": "I checked: these items really left. The missing quantity will be fixed later by a count or a receipt.",
    "goBack": "Go back and change",
    "confirm": "Confirm and validate",
    "footnote": "Only people allowed to confirm negative stock see this button. Others are asked to call a manager."
  },
  "detail": {
    "locked": "Locked · validated {{when}} by {{name}}",
    "lockedHint": "A validated operation never changes. If it was a mistake, reverse it: a new entry undoes it and both stay in the history.",
    "export": "Export to Excel",
    "reverse": "Reverse…",
    "reversedBy": "Reversed {{when}} by {{name}}",
    "negativeConfirmed": "Negative stock confirmed by {{name}}",
    "createdBy": "Created by",
    "movements": "Stock movements written",
    "transaction": "Transaction {{number}} · can never be edited",
    "balanceAfter": "Balance after",
    "reversal": "Reversal",
    "lines": "Lines",
    "nothingMoved": "Nothing has moved yet.",
    "history": "History of this document",
    "failed": "refused",
    "source": {
      "transfer": "Transit loss of transfer {{number}}",
      "count": "Count correction of {{number}}"
    },
    "openSource": "Open {{number}}",
    "sourceHint": "Created by its count or transfer, at the same time. It is not reversed on its own."
  },
  "reversal": {
    "title": {
      "stockIn": "Reverse this receipt?",
      "stockOut": "Reverse this issue?",
      "adjustment": "Reverse this correction?",
      "openingStock": "Reverse this opening stock?"
    },
    "text": "Nothing is deleted. A new entry undoes these quantities, at their original cost, and both entries stay in the history.",
    "why": "Why?",
    "note": "Details (optional)",
    "reasons": {
      "entered_twice": "Entered twice by mistake",
      "wrong_quantity": "Wrong quantity",
      "wrong_product": "Wrong product",
      "wrong_location": "Wrong location, re-entered",
      "wrong_cost": "Wrong cost",
      "other": "Other reason"
    },
    "keep": "Keep it",
    "confirm": "Reverse {{number}}",
    "done": "{{number}} reversed"
  },
  "approval": {
    "needs": "{{name}} needs a manager to approve this.",
    "worth": "It is worth {{value}} TND, which is above the {{limit}} TND limit set in Configuration. Nothing has changed in stock yet.",
    "nothingYet": "It is above the limit set in Configuration. Nothing has changed in stock yet.",
    "decision": "Your decision",
    "comment": "Comment",
    "commentHint": "Visible to {{name}} and kept in the log",
    "approve": "Approve and validate",
    "sendBack": "Send back to {{name}}",
    "commentNeeded": "Write a comment to send it back.",
    "approved": "Approved and validated",
    "sentBack": "Sent back to {{name}}",
    "waiting": "Waiting for a manager",
    "waitingText": "A manager approves it before the stock changes."
  }
}
